export default "__VITE_ASSET__DKPkJTZ3__"